<template>
  <div class="InputGroup InputGroup--with-icon">
    <input
      id="search-input"
      type="text"
      :value="value"
      class="InputGroup__field"
      :placeholder="placeholder"
      @input="updateValue($event.target.value)"
      @keyup.enter="$emit('search')"
    />
    <IconBase
      width="24"
      height="24"
      class="InputGroup__icon"
      iconName="email"
      @click.native="$emit('search')"
    >
      <IconSearch />
    </IconBase>
  </div>
</template>

<script>
import IconSearch from "./icons/IconSearch";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    }
  },
  components: {
    IconSearch
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.InputGroup--with-icon .InputGroup__field {
  padding: 0.625em 1.5em 0.625em 1em;
}

.InputGroup__icon {
  right: 0.5em;
}

#search-input {
  max-height: 40px;
}
</style>
